import React from 'react'
import { icons } from './iconMap'
import './Icon.css'

const SIZE_MAP = {
  '1x': 16,
  sm: 14,
  lg: 20,
  '2x': 24,
  '3x': 32,
  '4x': 48,
}

export default function Icon({ icon, size = '2x', className = '', spin, spinPulse, ...rest }) {
  const resolvedIcon = typeof icon === 'string' ? icons[icon] : null
  if (!resolvedIcon) return null

  const pxSize = SIZE_MAP[size] ?? (typeof size === 'number' ? size : 16)

  let finalClassName = className
  if (spin) finalClassName = `${className} icon-spin`.trim()
  if (spinPulse) finalClassName = `${className} icon-spin-pulse`.trim()

  const PhosphorIcon = resolvedIcon
  return <PhosphorIcon size={pxSize} weight="fill" className={finalClassName} {...rest} />
}

export { ICON } from './iconMap'
